import { useAppState } from '@/shared/stores/app-store/app-store';

import { type Intl } from './types';

export const useIntl = (): Intl => {
  const { messages } = useAppState();

  const getTranslatedMessage: Intl = (id: string) => {
    const msg = messages[id];
    if (!msg) {
      console.warn(makeErrMessage(id));

      return id;
    }
    return msg;
  };

  const makeErrMessage = (wrongId: string) => {
    return `[intl]: Id "${wrongId}" not found`;
  };

  return getTranslatedMessage;
};
